import { App } from 'vue';
import BTabs from './BTabs.vue';
import BTabPane from './BTabPane.vue';
BTabs.install = (app: App): void => {
  app.component(BTabs.name, BTabs)
  app.component(BTabPane.name, BTabPane)
}
const _BTabs= BTabs

export default _BTabs
